export default "__VITE_ASSET__DYA7UpVb__"